import { render, staticRenderFns } from "./dialogDevOptions.vue?vue&type=template&id=2c5287f1&scoped=true"
import script from "./dialogDevOptions.vue?vue&type=script&lang=js"
export * from "./dialogDevOptions.vue?vue&type=script&lang=js"
import style0 from "./dialogDevOptions.vue?vue&type=style&index=0&id=2c5287f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5287f1",
  null
  
)

export default component.exports